(ns com.theplantscape.plant-web.pages.diagram.view
  (:require
   [clojure.string :as str]
   [com.theplantscape.local-store.ensemble
    :as db
    :refer [add-new-plant
            fetch-diagram-settings
            fetch-plant-eid-from-uuid
            layers
            namespace-map
            store-diagram-settings]]
   [com.theplantscape.plant-web.components.plants.link :refer [plant-link]]
   [com.theplantscape.plant-web.components.search :as c]
   [com.theplantscape.plant-web.components.tailwind.forms.diagram-setup
    :refer [diagram-setup-form]]
   [com.theplantscape.plant-web.components.tailwind.icons.gear
    :refer [icon-gears]]
   [com.theplantscape.plant-web.components.tailwind.icons.search
    :refer [icon-search]]
   [com.theplantscape.plant-web.draw.actions
    :refer [configure-tool plant-info-modal set-tool]]
   [com.theplantscape.plant-web.draw.canvas-actions :refer [action]]
   [com.theplantscape.plant-web.draw.components.ui-svg-diagram
    :refer [ui-svg-diagram]]
   [com.theplantscape.plant-web.draw.db :refer [placed-plants-bind]]
   [com.theplantscape.plant-web.draw.db-store :as db-local-store]
   [com.theplantscape.plant-web.draw.db.app-db
    :refer [tools-bind update-tool-usage]]
   [com.theplantscape.plant-web.draw.events
    :as evt
    :refer [mouse-history reset-state]]
   [com.theplantscape.plant-web.draw.formatting :refer [plant-name]]
   [com.theplantscape.plant-web.draw.points :refer [points->str]]
   [com.theplantscape.plant-web.draw.state
    :refer [app-state
            compass-rotation
            toggle-compass-map-rotate
            configure-modal
            diagram-settings
            reset-editing
            set-mode
            site-state
            svg-transform
            toggle-compass
            toggle-modal
            update-zoom]]
   [com.theplantscape.plant-web.draw.ui-plant-info :refer [ui-plant-info]]
   [com.theplantscape.svg-generation.ensemble :as svg]
   [com.theplantscape.web-ui.ensemble :as u :refer [icon-palette]]
   [com.theplantscape.web-ui.svg.canvas :refer [ui-svg-canvas]]
   [com.theplantscape.web-ui.svg.helpers :as svgh]
   [com.theplantscape.web-ui.tailwind.ensemble
    :refer [icon-toolbar select-tool simple-list simple-modal ui-compass-popup]]
   [reagent.core :as r]
   [reagent.dom.server :refer [render-to-string]]))


(defn ui-head-diagram [path-params]
  (prn "head")
  (prn path-params)
  {:mh-head [:title "The Plantscape - User diagram"]
   :mh-og-title [:meta {"property" "og:title" "content" "The Plantscape - Garden design"}]
   :mh-og-url [:meta {"property" "og:url" "content" "https://theplantscape.com"}]
   :mh-og-type [:meta {"property" "og:type" "content" "website"}]
   :mh-og-description [:meta {"property" "og:description" "content" "test title"}]
   :mh-og-image [:meta {"property" "og:image" "content" (str "https://theplantscape.com/api/v2/diagrams/png/" (:id path-params))}]
                     #_#_:mh-og-image [:meta {"property" "og:image" "content" "https://img.theplantscape.com/api/image/pf/diagram/41c60aef-f5bf-4b7f-8eba-88c1c5600f36.png?p=large"}]
   :mh-description [:meta {"name" "description"}]
   :mh-keywords [:meta {"name" "keywords"}]
   :mh-robots [:meta {"name" "robots" "content" "index, follow"}]}
  )

#_(defn export-svg []
    (h/download-data-url "test.svg" (h/data-uri-svg (render-to-string [svgh/ui-svg "export" [ui-svg-diagram 600 600]]))))

(defn store-diagram []
  (db-local-store/store-database
   db/diag))

(defn ui-dialog []
  (let [state (r/cursor site-state [:modal])]
    (fn []
      [:div#ui-dialog {:key "ui-modal"}
       (when (:visible @state)
         [simple-modal
          {:body (:body @state)
           :title (:title @state)
           :close-fn toggle-modal}])])))

(defn ui-plant-dialog-body [plant-layer]
  [c/ui-plant-search c/search-on-click])

(defn ui-toolbar-diagram []
  [icon-toolbar
   [{:icon "fa-trash" :label "Trash" :on-click #(reset-state)}
    {:icon "fa-save" :label "Load" :on-click #(db-local-store/restore-database db/diag)}
    {:icon "fa-save" :label "Save" :on-click #(db-local-store/store-database db/diag)}
    {:icon "fa-save" :label "Export" :on-click #(svgh/export-svg [ui-svg-diagram 600 600])}]])

(defn insert-plant-mode [plant]
  (set-mode :insert (-> plant :plant/type))
  (add-new-plant (namespace-map :plant (-> plant)))
  (swap! app-state assoc-in [:current :plant]
         (fetch-plant-eid-from-uuid (-> plant :plant/id))))

(defn ui-diagram-key []
  (let [plants (placed-plants-bind)]
    (fn []
      [:<>
       (simple-list
        @plants
        (fn [plant]
          [:<>
           [:div.flex.items-center.justify-center
            [plant-link (-> plant :plant :plant/id)]
            (:id plant)]
           [:div.flex.items-center.justify-center {:on-click #(plant-info-modal (:id plant))}
            (plant-name (-> @app-state :visual :names) (:plant plant))]
           [:div.flex.items-center.justify-center.text-sm
            [:span.px-3.py-1.text-blue-200.bg-blue-600.rounded-full
             {:on-click
              (fn [_]
                (insert-plant-mode (-> plant :plant))

                ;;(add-new-plant (namespace-map :plant (-> plant :plant)))

                ;;(set-mode :insert (-> plant :plant :plant/type))
                #_(swap! app-state assoc-in [:current :plant]
                         (fetch-plant-eid-from-uuid (-> plant :plant :plant/id)))

                #_(swap! app-state assoc :selected {:eid (-> plant :plants first #_:db/id #_#_:plant :plant/id)
                                                    :plants [plant]
                                                    :object (fetch-plant (-> plant :plants first))}))}
             (:count plant)]]]))])))

(defn ui-layers []
  [:<>
   (map-indexed (fn [idx layer] [:div.bg-light-blue {:key idx} layer]) (layers))])

#_(defn dragging [xy]
    (when (-> @app-state :mouse :button :dragging)
      (move-ob xy)))

(defn ui-svg-preview
  [{:keys [width height view-box] :as size}]
  (let [position (r/cursor site-state [:current :geo :position])]

    (fn [{:keys [width height view-box] :as size}]
      [:g#preview-diagram {:style {:pointer-events "none"}}
       [svg/point :preview-point (-> @app-state :pointer :current :pos) "5"]
       (case (-> @app-state :mouse :tool)
         :path
         [svg/path
          {:entity-id :preview-path
           :points (mouse-history)
           :label "test"}]
         :patch
         [svg/patch {;;:entity-id :preview-patch
                     :points (-> @app-state :mouse :history)}]
         :area
         [svg/area {:entity-id :preview-aera
                     :points (-> @app-state :mouse :history)}]
         :structure
         [svg/structure  {:entity-id :preview-structure
                          :points (-> @app-state :mouse :history)}]
         ;[svg/point :default-tool (-> @app-state :pointer :current :pos) ]
         [svg/point :preview-point (-> @app-state :pointer :current :pos) "5"])

       (when (and (-> @app-state :mouse :multi)
                  (< 0 (-> @app-state :mouse :history count)))
         [apply svg/ruler
          (conj [(-> @app-state :pointer :current :pos)
                 (last (-> @app-state :mouse :history))]
                (-> @app-state :visual :units name)
                (-> @app-state :canvas :scale :font))])
       [svg/point :preview-point [0 0] "2"]
       [svg/marker {:entity-id  :gps-point :points @position #_(-> @site-state :current :geo-position)  :radius "2"}]
       ;[svg/point :preview-point (-> @app-state :pointer :current :pos) "5"]
       (doall (map-indexed (fn [idx xy] [:<> {:key idx} [svg/point idx xy (/ 3 (-> @app-state :canvas :zoom))]])
                           (-> @app-state :mouse :history)))])))

#_(defn ui-new-plant []
  (let [values (r/atom {})
        form (partial update-atom-hm values)]
    (fn []
      [:main.mw6.center
       (str @values)
       [:form.measure.center
        [:fieldset.ba.b--transparent.ph0.mh0
         [:legend.f4.fw6.ph0.mh0 "Add plant"]
         [:div.mt3
          [:label.db.fw6.lh-copy.f6 {:for "common-name"} "Common name"]
          [:input.pa2.input-reset.ba.bg-transparent.hover-bg-black.hover-white.w-100
           {:type "text" :name "common-name"
            :on-change form}]]
         [:div.mt3
          [:label.db.fw6.lh-copy.f6 {:for "scientific-name"} "Scientific name"]
          [:input.pa2.input-reset.ba.bg-transparent.hover-bg-black.hover-white.w-100
           {:type "text" :name "scientific-name"
            :on-change form}]]
         [:div.mt3
          [:label.db.fw6.lh-copy.f6 {:for "type"} "Plant Type"]
          [:select.pa2.input-reset.ba.bg-transparent.hover-bg-black.hover-white.w-100
           {:type "text" :name "type" :on-change form}
           (map (fn [type] [:option {:value type}
                            (-> type name str/capitalize)]) (plant-types))]]]]])))

#_(defn ui-tabs [tabs]
    (let [selected (r/atom 0)]
      (fn [tabs]
        [:div {:style {:width "100%"}}
         [:nav.bb.tc.mw7
          (map-indexed (fn [idx {:keys [title]}]
                         [:a.f6.f5-l.link.bg-animate.hover-bg-light-green.dib.pa3.ph4-l
                          {:key idx :on-click #(reset! selected idx)} title]) tabs)]
         [:div {:style {:width "100%" :height "100%"}}
          (:body (nth tabs @selected))
          #_(map-indexed (fn [idx {:keys [body]}] [:div body]) tabs)]])))

(defn tool-palette []
  (let [tools (tools-bind)]
    (fn []
      [select-tool @tools
       {:select-tool (fn [{:keys [tool/action tool/name] :as tool}]
                       (update-tool-usage name)
                       (toggle-modal)
                       (set-tool action))}])))

(defn ui-canvas [width height]
  (let [canvas (r/cursor app-state [:canvas])
        view-box (str (points->str [(* -1 (/ (-> @app-state :canvas :view :width) 2))
                                    (* -1 (/ (-> @app-state :canvas :view :height) 2))])  " "
                      (points->str [(-> @app-state :canvas :view :width)
                                    (-> @app-state :canvas :view :height)]))
        compass-geo (r/cursor site-state [:current :geo])
        compass-form (r/cursor site-state [:compass-form-show])
        compass (r/cursor site-state [:compass])
        compass-enabled (r/cursor site-state [:compass :enabled])]
    (fn [width height]
      [:div.bg-white {:style {:width "100%" :height "100%"}}
       [:div.relative.container.cursor-none
        {:style
         {:overflow "clip" :margin "auto" :width "100%" :height height}}
        [ui-svg-canvas
         "events"
         action
         nil
         {:transform (svg-transform)
          :view-box view-box}
         ;[:g]
         ;[ui-svg-patterns]
         [ui-svg-diagram {:width "100%" :height height :view-box view-box}]
         [ui-svg-preview {:width "100%" :height height :view-box view-box}]]

        (when (true? @compass-form)
          [:div#gps.absolute.top-0.bg-white.w-full.h-full {:style {:z-index "9"}}

           [:div.m-4.cursor-default
            [ui-compass-popup
             {:enabled @compass-enabled
              :toggle-gps-value (-> @compass :enabled)
              :toggle-rotation-value (-> @compass :map :rotate)
              :close-fn (fn [] (reset! compass-form false))
              :toggle-fn toggle-compass
              :toggle-map-rotate-fn toggle-compass-map-rotate
              :error (:error @compass-geo)
              :accuracy (-> @site-state :current :geo :accuracy)
              :geo-position
              (-> @site-state :location)}]]])

        [:div.absolute.cursor-default {:on-click #(reset! compass-form true) #_toggle-compass
                                       :style {:top "5px" :left "5px"}}
         [svg/compass 75 (compass-rotation) @compass-enabled]]

        [:div.absolute.flex.flex-row.cursor-pointer.h-8.right-2.top-2
         (when (not-any? #(= % (-> @app-state :selected :tool)) [:select nil])
           [:div.w-8.h-8 {:on-click reset-editing} u/icon-close])
         [:div.w-8.h-8 {:on-click #(configure-tool :insert [c/ui-plant-search c/search-on-click])} [icon-search]]
         [:div.w-8.h-8 {:on-click #(diagram-settings :show)} [icon-gears]]
         [:div.w-8.h-8 {:on-click (fn [e]
                                    (.preventDefault e)
                                    (configure-modal
                                     "Select / Search for a tool"
                                     [tool-palette]))} icon-palette]
         [svg/zoom
          :vertical
          32
          (fn [e] (.stopPropagation e)
            (update-zoom :inc))
          (fn [e] (.stopPropagation e)
            (update-zoom :dec))]]]])))


(defn ui-app []
  (let [view (r/cursor app-state [:canvas :view])
        settings (r/cursor app-state [:diagram :settings])]
    (fn []
      (if (diagram-settings)
        [:div #_@settings #_.absolute.ba #_{:style {:top "0px" :width "100%" :height (-> @app-state :canvas :height)}}
         [diagram-setup-form
          "Settings"
          settings
          {:close-fn #(diagram-settings :hide)
           :on-submit (fn store-save-settings [values]
                        ;(reset! @settings values)
                        (store-diagram-settings values)
                        (store-diagram))}]]
        [:div
         [ui-canvas
          (-> @app-state :canvas :width)
          (-> @app-state :canvas :height)]
         [ui-diagram-key]
         [ui-plant-info]]))))

(defn ui-page-diagram [route]
  [ui-app])

(comment
  (configure-modal
   "Select / Search for a tool"
   [tool-palette])
  (store-diagram-settings (-> @app-state :diagram :settings :values))
  (fetch-diagram-settings)

  (-> @app-state :selected )
  (-> @app-state :current :plant )
  (-> @app-state :current :plant :db/id)
  (-> @app-state :diagram :settings :values)
  (render-to-string [ui-svg-diagram "100%" 600]))



